import React, { useEffect, useState } from 'react';

const card = { background: '#1a1d27', border: '1px solid #2a2e3a', borderRadius: 12, padding: 16 };
const title = { fontSize: 13, color: '#8b8fa3', fontWeight: 600, marginBottom: 8, textTransform: 'uppercase', letterSpacing: 0.5 };
const inp = { background: '#0a0d14', border: '1px solid #2a2e3a', borderRadius: 6, padding: '8px 12px', color: '#e4e6eb', fontSize: 13, width: '100%', boxSizing: 'border-box' };
const btn = (bg) => ({ padding: '8px 16px', borderRadius: 6, border: 'none', background: bg, color: bg === '#f43f5e' ? '#fff' : '#0a0d14', cursor: 'pointer', fontWeight: 600, fontSize: 12 });

const fmtDate = (secs) => secs ? new Date(secs * 1000).toLocaleDateString('hu-HU') : '—';
const toInputDate = (secs) => secs ? new Date(secs * 1000).toISOString().slice(0, 10) : '';

export default function Comped() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [msg, setMsg] = useState(null);

  // Form
  const [email, setEmail] = useState('');
  const [credits, setCredits] = useState(125);
  const [note, setNote] = useState('');
  const [expires, setExpires] = useState('');

  // Edit
  const [editUid, setEditUid] = useState(null);
  const [editCredits, setEditCredits] = useState(125);
  const [editNote, setEditNote] = useState('');
  const [editExpires, setEditExpires] = useState('');
  const [editActive, setEditActive] = useState(true);

  const load = async () => {
    setLoading(true); setError(null);
    try {
      const res = await fetch('/api/comped', { credentials: 'include' });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      setUsers(await res.json());
    } catch (e) { setError(e.message); }
    finally { setLoading(false); }
  };

  useEffect(() => { load(); }, []);

  const flash = (m, ok = true) => { setMsg({ text: m, ok }); setTimeout(() => setMsg(null), 4000); };

  const handleAdd = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch('/api/comped', {
        method: 'POST', credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, monthlyCredits: credits, note, expiresAt: expires || undefined }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error);
      flash(`${email} hozzáadva`);
      setEmail(''); setNote(''); setCredits(125); setExpires('');
      load();
    } catch (e) { flash(e.message, false); }
  };

  const handleEdit = (u) => {
    setEditUid(u.uid);
    setEditCredits(u.monthlyCredits);
    setEditNote(u.note);
    setEditExpires(toInputDate(u.expiresAt));
    setEditActive(u.active);
  };

  const handleSave = async () => {
    try {
      const res = await fetch(`/api/comped/${editUid}`, {
        method: 'PUT', credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ monthlyCredits: editCredits, active: editActive, note: editNote, expiresAt: editExpires || undefined }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error);
      flash('Mentve');
      setEditUid(null);
      load();
    } catch (e) { flash(e.message, false); }
  };

  const handleToggle = async (u) => {
    try {
      const res = await fetch(`/api/comped/${u.uid}`, {
        method: 'PUT', credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ active: !u.active }),
      });
      if (!res.ok) throw new Error('Hiba');
      flash(`${u.email} ${!u.active ? 'aktiválva' : 'deaktiválva'}`);
      load();
    } catch (e) { flash(e.message, false); }
  };

  const handleDelete = async (u) => {
    if (!window.confirm(`Biztosan törlöd: ${u.email}?`)) return;
    try {
      const res = await fetch(`/api/comped/${u.uid}`, { method: 'DELETE', credentials: 'include' });
      if (!res.ok) throw new Error('Hiba');
      flash(`${u.email} törölve`);
      load();
    } catch (e) { flash(e.message, false); }
  };

  return (
    <div style={{ padding: 20 }}>
      <h1 style={{ color: '#e4e6eb', margin: 0, fontSize: 24, marginBottom: 20 }}>Comped felhasználók</h1>

      {msg && (
        <div style={{ padding: '10px 16px', borderRadius: 8, marginBottom: 16, background: msg.ok ? '#1f3a1e' : '#3a1e1e', color: msg.ok ? '#86efac' : '#fca5a5', fontSize: 13 }}>
          {msg.text}
        </div>
      )}

      {/* Hozzáadás */}
      <div style={{ ...card, marginBottom: 20 }}>
        <div style={title}>Új comped felhasználó</div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 12, marginTop: 12 }}>
          <div>
            <label style={{ fontSize: 11, color: '#8b8fa3', display: 'block', marginBottom: 4 }}>Email *</label>
            <input style={inp} value={email} onChange={e => setEmail(e.target.value)} placeholder="user@example.com" />
          </div>
          <div>
            <label style={{ fontSize: 11, color: '#8b8fa3', display: 'block', marginBottom: 4 }}>Havi kredit</label>
            <input style={inp} type="number" value={credits} onChange={e => setCredits(parseInt(e.target.value) || 0)} />
          </div>
          <div>
            <label style={{ fontSize: 11, color: '#8b8fa3', display: 'block', marginBottom: 4 }}>Lejárat</label>
            <input style={inp} type="date" value={expires} onChange={e => setExpires(e.target.value)} />
          </div>
          <div>
            <label style={{ fontSize: 11, color: '#8b8fa3', display: 'block', marginBottom: 4 }}>Megjegyzés</label>
            <input style={inp} value={note} onChange={e => setNote(e.target.value)} placeholder="pl. influencer neve" />
          </div>
        </div>
        <div style={{ marginTop: 12 }}>
          <button style={btn('#00D4FF')} onClick={handleAdd}>Hozzáadás</button>
        </div>
      </div>

      {/* Lista */}
      {loading ? (
        <div style={{ color: '#8b8fa3' }}>Betöltés...</div>
      ) : error ? (
        <div style={{ color: '#f43f5e' }}>Hiba: {error}</div>
      ) : (
        <div style={card}>
          <div style={title}>Aktív comped felhasználók ({users.length})</div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            {users.map(u => (
              <div key={u.uid} style={{
                background: '#0a0d14', borderRadius: 8, padding: '12px 16px',
                border: u.active ? '1px solid #2a2e3a' : '1px solid #3a2e2e',
                opacity: u.active ? 1 : 0.6,
              }}>
                {editUid === u.uid ? (
                  /* Edit mode */
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: 10 }}>
                      <div>
                        <label style={{ fontSize: 10, color: '#8b8fa3' }}>Havi kredit</label>
                        <input style={inp} type="number" value={editCredits} onChange={e => setEditCredits(parseInt(e.target.value) || 0)} />
                      </div>
                      <div>
                        <label style={{ fontSize: 10, color: '#8b8fa3' }}>Lejárat</label>
                        <input style={inp} type="date" value={editExpires} onChange={e => setEditExpires(e.target.value)} />
                      </div>
                      <div>
                        <label style={{ fontSize: 10, color: '#8b8fa3' }}>Megjegyzés</label>
                        <input style={inp} value={editNote} onChange={e => setEditNote(e.target.value)} />
                      </div>
                      <div>
                        <label style={{ fontSize: 10, color: '#8b8fa3' }}>Aktív</label>
                        <select style={inp} value={editActive ? 'true' : 'false'} onChange={e => setEditActive(e.target.value === 'true')}>
                          <option value="true">Igen</option>
                          <option value="false">Nem</option>
                        </select>
                      </div>
                    </div>
                    <div style={{ display: 'flex', gap: 8 }}>
                      <button style={btn('#22c55e')} onClick={handleSave}>Mentés</button>
                      <button style={btn('#2a2e3a')} onClick={() => setEditUid(null)}>Mégse</button>
                    </div>
                  </div>
                ) : (
                  /* View mode */
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 10 }}>
                    <div style={{ flex: 1, minWidth: 200 }}>
                      <div style={{ fontSize: 14, color: '#e4e6eb', fontWeight: 600 }}>{u.email}</div>
                      <div style={{ fontSize: 11, color: '#8b8fa3', marginTop: 2 }}>
                        {u.note && <span>{u.note} · </span>}
                        {u.monthlyCredits} POI/hó · Lejárat: {fmtDate(u.expiresAt)}
                        {u.lastGrant && <span> · Utolsó: {fmtDate(u.lastGrant)}</span>}
                      </div>
                    </div>
                    <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
                      <span style={{
                        padding: '2px 8px', borderRadius: 4, fontSize: 10, fontWeight: 600,
                        background: u.active ? '#1f3a1e' : '#3a1e1e',
                        color: u.active ? '#86efac' : '#fca5a5',
                      }}>{u.active ? 'Aktív' : 'Inaktív'}</span>
                      <button style={{ ...btn('#2a2e3a'), color: '#e4e6eb', fontSize: 11 }} onClick={() => handleToggle(u)}>
                        {u.active ? 'Deakt.' : 'Akt.'}
                      </button>
                      <button style={{ ...btn('#2a2e3a'), color: '#e4e6eb', fontSize: 11 }} onClick={() => handleEdit(u)}>Szerk.</button>
                      <button style={{ ...btn('#f43f5e'), fontSize: 11 }} onClick={() => handleDelete(u)}>Törlés</button>
                    </div>
                  </div>
                )}
              </div>
            ))}
            {users.length === 0 && <div style={{ color: '#8b8fa3', fontSize: 13 }}>Nincs comped felhasználó</div>}
          </div>
        </div>
      )}
    </div>
  );
}
